import React from "react";
import { useI18n } from "../../providers/I18nProvider";

const CLASS_BY_STATUS = {
  pending_supervisor: "sat-badge sat-badge--pending",
  pending_it: "sat-badge sat-badge--pending",
  pending_manager: "sat-badge sat-badge--it-approved",
  pending_hr: "sat-badge sat-badge--manager-approved",
  completed: "sat-badge sat-badge--completed",
  rejected: "sat-badge sat-badge--rejected",
  cancelled: "sat-badge sat-badge--cancelled",
};

const StatusBadge = ({ status }) => {
  const { t } = useI18n();
  const className = CLASS_BY_STATUS[status] || "sat-badge";
  return <span className={className}>{t(`satRequest.status.${status}`) || status}</span>;
};

export default StatusBadge;
